// src/components/TaskStats.tsx
import React from 'react';
import { Task } from '../api/tasks';

interface TaskStatsProps {
  tasks: Task[];
  onStatusClick: (status: string) => void;
}

export function TaskStats({ tasks, onStatusClick }: TaskStatsProps) {
  const stats = [
    { label: 'All Tasks', value: tasks.length, color: '#4F46E5', bg: '#EEF2FF', icon: '📋', filter: 'ALL' },
    { label: 'To Do', value: tasks.filter(t => t.status === 'TODO').length, color: '#6B7280', bg: '#F3F4F6', icon: '📝', filter: 'TODO' },
    { label: 'In Progress', value: tasks.filter(t => t.status === 'IN_PROGRESS').length, color: '#2563EB', bg: '#EFF6FF', icon: '⚙️', filter: 'IN_PROGRESS' },
    { label: 'In Review', value: tasks.filter(t => t.status === 'IN_REVIEW').length, color: '#7C3AED', bg: '#F5F3FF', icon: '🔍', filter: 'IN_REVIEW' },
    { label: 'Blocked', value: tasks.filter(t => t.status === 'BLOCKED').length, color: '#DC2626', bg: '#FEF2F2', icon: '🚫', filter: 'BLOCKED' },
    { label: 'Completed', value: tasks.filter(t => t.status === 'DONE').length, color: '#059669', bg: '#ECFDF5', icon: '✅', filter: 'DONE' },
  ];

  const overdueCount = tasks.filter(t => t.is_overdue && t.status !== 'DONE' && t.status !== 'CANCELLED').length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-3 mb-6">
      {stats.map((stat) => (
        <div
          key={stat.label}
          onClick={() => onStatusClick(stat.filter)}
          className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 cursor-pointer hover:shadow-md transition-all hover:scale-105"
        >
          <div className="flex items-center justify-between">
            <span className="text-2xl">{stat.icon}</span>
            <span className="text-2xl font-bold" style={{ color: stat.color }}>{stat.value}</span>
          </div>
          <div className="text-xs font-medium text-gray-500 mt-1">{stat.label}</div>
        </div>
      ))}
      
      {overdueCount > 0 && (
        <div
          onClick={() => onStatusClick('OVERDUE')}
          className="bg-white rounded-xl p-3 shadow-sm border border-red-100 cursor-pointer hover:shadow-md transition-all hover:scale-105"
        >
          <div className="flex items-center justify-between">
            <span className="text-2xl">⚠️</span>
            <span className="text-2xl font-bold text-red-600">{overdueCount}</span>
          </div>
          <div className="text-xs font-medium text-gray-500 mt-1">Overdue</div>
        </div>
      )}
    </div>
  );
}